// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__EKr8c","rootMobile":"styles_rootMobile__2Xoaf"};